/**
 * @generated SignedSource<<545032a8054c3cafffb4d98de5e84a81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateOrganizationSlackMembershipInput = {
  organizationId: string;
  userId: string;
};
export type useAddCompletedSlackInviteMutation$variables = {
  input: CreateOrganizationSlackMembershipInput;
};
export type useAddCompletedSlackInviteMutation$data = {
  readonly createOrganizationSlackMembership: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly organizationId: string;
      readonly organizationMembershipId: string;
      readonly userId: string;
    } | null;
  };
};
export type useAddCompletedSlackInviteMutation = {
  response: useAddCompletedSlackInviteMutation$data;
  variables: useAddCompletedSlackInviteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOrganizationSlackMembershipResponse",
    "kind": "LinkedField",
    "name": "createOrganizationSlackMembership",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrganizationSlackMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationMembershipId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddCompletedSlackInviteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAddCompletedSlackInviteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "32efd6e30963b188562f831ffdfd56c5",
    "id": null,
    "metadata": {},
    "name": "useAddCompletedSlackInviteMutation",
    "operationKind": "mutation",
    "text": "mutation useAddCompletedSlackInviteMutation(\n  $input: CreateOrganizationSlackMembershipInput!\n) {\n  createOrganizationSlackMembership(input: $input) {\n    node {\n      id\n      userId\n      organizationId\n      organizationMembershipId\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f939e7097949302488731d7fc02b2bf8";

export default node;
